<template>
    <div data-dusk="sub-tab-content" v-bind="$attrs" class="sub-tab-content">
      <lazy-component>
        <slot></slot>
      </lazy-component>
    </div>
</template>

<script>
export default {
  name: "SubTabContent.vue",

}
</script>

<style lang="scss" scoped>
</style>
